import { INotificationSlice, INotificationStore } from '@/types'
import { ActivityTypeUtil, NotificationItem } from '@/types/notification'

const initialState: INotificationStore = {
  items: [],
  unreadCount: 0,
}

export const createNotificationSlice = (set: any): INotificationSlice => ({
  notification: initialState,
  addSocketMessage: (item: NotificationItem) => {
    set((state: any) => ({
      notification: {
        ...state.notification,
        items: [item, ...state.notification.items],
      },
    }))
  },
  markAsRead: (eventID: string) => {
    set((state: any) => {
      let updated = [...state.notification.items]
      updated = updated.filter((e, i) => e.eventID != eventID)

      return {
        notification: {
          ...state.notification,
          items: updated,
          unreadCount: state.notification.unreadCount - 1,
        },
      }
    })
  },
  markAsReadForTopic: (topicID: string) => {
    set((state: any) => {
      const current = [...state.notification.items]
      let filtered = current.filter((e) => {
        let eventTopicID = ActivityTypeUtil.getTopicID(e)
        return topicID == eventTopicID
      })

      if (filtered?.length > 0) {
        const updatedUnRead = current.filter((e) => {
          let eventTopicID = ActivityTypeUtil.getTopicID(e)
          return topicID != eventTopicID
        })
        return {
          notification: {
            ...state.notification,
            items: [...updatedUnRead],
            unreadCount: state.notification.unreadCount - filtered.length,
          },
        }
      } else {
        return state
      }
    })
  },
  deleteAllMessages: () => {
    set((state: any) => ({
      notification: {
        ...state.notification,
        items: [],
      },
    }))
  },
  reset: () => set(initialState),
})

export default createNotificationSlice
